import React from 'react'
import classNames from 'classnames'
import { DateTime } from 'luxon'
import DateLogic from '../../../helpers/date-logic'
import Alerts from './alerts'
import Events from '../events'
import Hours from './hours'
import Header from './header'

function shouldShowEvent(event) {
  return (
    event.resourceType === 'ProductionCalendarEvent' ||
    event.resourceType === 'CalendarEvent' ||
    event.resourceType === 'ScheduleActivity' ||
    event.type === 'activity'
  )
}

const Day = ({ day, position }) => {
  let { date: time, entries, alerts, aquariumHours } = day
  let date = DateTime.fromISO(time, { zone: 'America/Chicago' })
  let isToday = DateLogic.isCurrentDay([date, date])
  let isPreviousDay = !isToday && date.ts < DateLogic.today.ts

  let events = entries.filter(shouldShowEvent)

  return (
    <div
      key={`day-${date}`}
      className={classNames('flex-1 p-24 lg:p-16 lg:m-1', {
        'bg-black-4': !isToday,
        'bg-depths': isToday,
        'hidden lg:block': isPreviousDay
      })}
    >
      <Header
        date={date}
        isToday={isToday}
      />
      <Hours
        hours={aquariumHours}
        highlight={isToday}
      />
      <Alerts alerts={alerts} />
      <Events
        events={events}
        position={position}
      />
    </div>
  )
}

export default Day
